import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OeAppService } from '../../shared/oe-app.service';
import { ProfileService } from '../../shared/profile.service';
import { TokenService } from '../../shared/token.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AccountSharingEventType } from '../account-sharing-event-type';
import { GTMService } from '../../shared/gtm.service';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { SharedAccountService } from '../../login/shared-account.service';
import { TranslationService } from '../../shared/translation.service';
import { WindowService } from '../../shared/window.service';

@Component({
  selector: 'lp2-account-sharing-page',
  template: '<iframe lp2UserwaySync *ngIf="src" id="account-sharing-iframe" [src]="src | safeUrl" frameborder="0" allow="microphone; autoplay; camera"></iframe>',
  styleUrls: ['./account-sharing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSharingPageComponent implements OnInit {
  public src: string = null;

  public getSrc(): Observable<string> | null {
    const personId = this.tokenService.getPersonIdFromTempToken();
    const token = this.tokenService.tempToken;
    const lang = this.translationService.getCurrentLanguage();
    return this.profileService.getContactByPersonId(personId, token).pipe(
      map(({ address }) => {
        return `${this.oeAppService.webAccountSharingPageHost}?env=${this.oeAppService.environment}&accessToken=${token}&countryId=${address.countryId}&lang=${lang}&personId=${personId}`;
      })
    );
  }

  constructor(
    private readonly oeAppService: OeAppService,
    private readonly profileService: ProfileService,
    private readonly tokenService: TokenService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly gtmService: GTMService,
    private readonly sharedAccountService: SharedAccountService,
    private readonly translationService: TranslationService,
    private readonly windowService: WindowService
  ) {
    window.addEventListener('message', this.handleEvents.bind(this), false);
  }

  ngOnInit(): void {
    this.getSrc().subscribe((src) => {
      this.src = src;
      this.cdRef.detectChanges();
    });
  }

  private handleEvents({ data, origin }) {
    if (isIFrameSameOrigin(window.location.href, origin)) {
      return;
    }
    switch (data.type) {
      case AccountSharingEventType.ACCOUNT_SHARING_SUCCESS_EVENT:
        const { accessToken } = data.data;
        this.sharedAccountService.removeSharingAccountPendingValidationValue();
        this.sharedAccountService.removeSharingAccountUrlValue();
        const url = this.sharedAccountService.getSharingAccountUrlValue();
        this.sharedAccountService.updateAccountSharingAccessToken$(accessToken).subscribe(() => {
          this.tokenService.removeTempToken();
          this.windowService.redirectToUrl(url || '/');
        });
        break;
      case AccountSharingEventType.ACCOUNT_SHARING_TRACKING_EVENT:
        if (!data.data.event) {
          this.gtmService.sendGA4Event(data.data);
          break;
        }
        this.gtmService.sendGA4Event(data.data.event, data.data.params);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/account-sharing/account-sharing-page/account-sharing-page.component.ts